var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 4.5C2.25 4.18934 2.50184 3.9375 2.8125 3.9375H15.1875C15.4982 3.9375 15.75 4.18934 15.75 4.5C15.75 4.81066 15.4982 5.0625 15.1875 5.0625H2.8125C2.50184 5.0625 2.25 4.81066 2.25 4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 9C2.25 8.68934 2.50184 8.4375 2.8125 8.4375H15.1875C15.4982 8.4375 15.75 8.68934 15.75 9C15.75 9.31066 15.4982 9.5625 15.1875 9.5625H2.8125C2.50184 9.5625 2.25 9.31066 2.25 9Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 12.9375C2.50184 12.9375 2.25 13.1893 2.25 13.5C2.25 13.8107 2.50184 14.0625 2.8125 14.0625H15.1875C15.4982 14.0625 15.75 13.8107 15.75 13.5C15.75 13.1893 15.4982 12.9375 15.1875 12.9375H2.8125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBurger);
export default __webpack_public_path__ + "static/media/ic_burger.50e39852.svg";
export { ForwardRef as ReactComponent };